/*
 * Copyright (c) 2019.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterLink} from '@angular/router';
import {JwtModule} from '@auth0/angular-jwt';
import {NbAutocompleteModule, NbButtonModule, NbInputModule, NbSelectModule} from '@nebular/theme';
import {Environment, SharedModule} from 'compob2b-libs';
import {AuthInterceptor} from './interceptors/auth-interceptor';
import {AuthStateService} from './services/auth-state.service';
import {AuthGuardService} from './services/auth.guard.service';
import {AuthService} from './services/auth.service';
import {ForgotService} from './services/forgot.service';
import {ResetService} from './services/reset.service';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    NbAutocompleteModule,
    NbInputModule,
    NbSelectModule,
    // Lambda вместо прямой reference: разрывает eager top-level evaluation
    // в test-режиме, где @analogjs AOT-pass грузит все NgModule из tsconfig
    // include и AuthService может быть undefined на момент module-init из-за
    // circular deps libs ↔ auth. Runtime эквивалент — JwtModule всё равно
    // вызывает getter лениво при чтении токена.
    JwtModule.forRoot({config: {tokenGetter: () => AuthService.tokenGetter()}}),
    NbButtonModule,
    RouterLink
  ],
  providers: [
    AuthService,
    AuthStateService,
    ForgotService,
    AuthGuardService,
    ResetService,
    {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true}
  ]
})
export class AuthModule {

  public static forRoot(environment: Environment): ModuleWithProviders<AuthModule> {

    return {
      ngModule: AuthModule,
      providers: [
        {provide: 'environment', useValue: environment},
        {provide: Environment, useValue: environment}
      ]
    };
  }

}
